import React, { ChangeEvent, useEffect, useState } from 'react';
import { useTranslation } from 'react-i18next';
import { useDispatch } from 'react-redux';
import { useHistory } from 'react-router-dom';
import { SourceData } from '../../../../types';
import * as Styled from './SourceRow.styles';
import CustomToggle from '../../../../../../components/CustomToggle';
import * as actions from '../../../../../SourcesPage/actions';
import * as actionsNetwork from '../../../../actions';

interface SourceRowParam {
  data: SourceData;
  index: number;
  disableReasons: string[] | null;
}

const SourceRow = ({ data, index, disableReasons }: SourceRowParam) => {
  const { t } = useTranslation();
  const dispatch = useDispatch();
  const history = useHistory();
  const [checked, setChecked] = useState<boolean>(data.activated);
  const [disableButton, setDisableButton] = useState<boolean>(true);
  const networkCode = history.location.pathname.split('/')[2];
  const [comments, setComments] = useState<string>('');
  const [error, setError] = useState<boolean>(false);
  const [active, setActive] = useState<boolean>(data?.active || false);
  const [activeInfo, setActiveInfo] = useState<{
    activeUpdatedBy: string | null;
    activeUpdatedAt: Date | null;
  }>({
    activeUpdatedBy: data?.activeUpdatedBy || null,
    activeUpdatedAt: data?.activeUpdatedAt
      ? new Date(data?.activeUpdatedAt) || ''
      : null,
  });

  const formattedDate = (date: Date | null) =>
    date
      ? `${date.toLocaleDateString('ru-RU', {
          timeZone: 'Asia/Almaty',
        })} ${date.toLocaleTimeString('ru-RU', {
          hour: '2-digit',
          minute: '2-digit',
          timeZone: 'Asia/Almaty',
        })}`
      : '';

  useEffect(() => {
    if (checked === data.activated && active === data.active) {
      setDisableButton(true);
    } else setDisableButton(false);
  }, [checked, active, data]);

  useEffect(() => {
    error && setError(false);
  }, [comments]);

  const handleChangeActivationProducts = () => {
    if (checked) {
      dispatch(
        actions.activateSource.request({
          sourceCode: data.code,
          postEffect: () =>
            dispatch(
              actionsNetwork.getSourcesByNetwork.request({ networkCode })
            ),
        })
      );
    } else if (comments.trim() === '') {
      setError(true);
    } else {
      dispatch(
        actions.deactivateSource.request({
          sourceCode: data.code,
          message: comments.trim(),
          postEffect: () =>
            dispatch(
              actionsNetwork.getSourcesByNetwork.request({ networkCode })
            ),
        })
      );
    }
    if (active !== data?.active) {
      dispatch(
        actions.setActiveStatus.request({
          sourceCode: data.code,
          status: active,
          postEffect: () =>
            actionsNetwork.getSourcesByNetwork.request({ networkCode }),
        })
      );
    }
  };

  const handleInputChange = (e: ChangeEvent<HTMLInputElement>) => {
    setComments(e.target.value);
  };

  const handleToSource = (code: string, e: any) => {
    e.target.classList.value === 'table-cell' &&
      history.push(`/sources/${code}`);
  };

  return (
    <Styled.SourceRow onClick={(e) => handleToSource(data.code, e)}>
      <td className="table-cell">{index}</td>
      <td className="table-cell">{data.name}</td>
      <td className="table-cell">{data.city}</td>
      <td className="table-cell">{data.address}</td>
      <td className="table-cell">{data.openingHours}</td>
      <td className="table-cell">{data.lastSync}</td>
      <td className="table-cell">
        <div>
          <div className="toggle-block">
            <CustomToggle
              onChange={() => {
                setChecked(!checked);
                setDisableButton(false);
              }}
              id={data.name}
              checked={checked}
              variant="standart"
            />
            <div className="disableUpdatedAt"> {data.disableUpdatedAt} </div>
          </div>
          {!disableButton && !checked && (
            <div className="wrapper">
              <div className="container-textarea">
                <input
                  placeholder={t('SourcesPage.YOUR_COMMENT')}
                  value={comments}
                  onChange={handleInputChange}
                  type="text"
                  className={error ? 'input-comments-error' : 'input-comments'}
                  maxLength={30}
                />
              </div>
              <select
                onChange={(e) => setComments(e.target.value)}
                value={comments}
                className="select-group"
              >
                <option value="" disabled>
                  {t('SourcesPage.CHOSE_REASON')}
                </option>

                {disableReasons?.map((text) => (
                  <option value={text} key={text}>
                    {text}
                  </option>
                ))}
              </select>
            </div>
          )}
          {disableButton && !checked && data.comments && (
            <p className="comment">{data.comments}</p>
          )}
          {error && (
            <p className="comment-error">{t('SourcesPage.ERROR_COMMENTS')}</p>
          )}
          <div className="toggle-block-active ">
            <CustomToggle
              onChange={() => {
                setActive(!active);
                setDisableButton(false);
              }}
              id="active pharmacy"
              checked={active}
              variant="standart"
            />
            <div className="activeUpdatedAt">
              <span>
                {active ? t('SourcesPage.ACTIVE') : t('SourcesPage.INACTIVE')}
              </span>
              <span className="active-info">
                {formattedDate(activeInfo.activeUpdatedAt) || ''}
              </span>
              <span className="active-info">
                {activeInfo.activeUpdatedBy || ''}
              </span>
            </div>
          </div>
          <div
            className={`save-btn ${disableButton && 'disable'}`}
            onClick={handleChangeActivationProducts}
          >
            {t('SourcesPage.SAVE')}
          </div>
          {data && data.hasSyncError && (
            <div className="container-error">
              {t('SourcesPage.ERROR')}
              <div className="error"> {t('SourcesPage.DETAILS_ERROR')}</div>
            </div>
          )}
        </div>
      </td>
    </Styled.SourceRow>
  );
};

export default SourceRow;
